var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.showMissingModule
    ? _c(
        "w-card-content",
        [_c("app-missing-module", { attrs: { "module-id": _vm.moduleId } })],
        1
      )
    : _vm.files.length != 0 && _vm.isAllowed
    ? _c(
        "w-list",
        [
          _vm._l(_vm.files, function (item) {
            return _c(
              "w-list-item",
              { key: item.ID },
              [
                _c("w-list-item-text", [_vm._v(_vm._s(item.getName()))]),
                _c(
                  "w-list-item-action",
                  [
                    !_vm.isOpeningPreview(item)
                      ? _c(
                          "w-button",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.$ct("common.preview"),
                                expression: "$ct('common.preview')",
                              },
                            ],
                            attrs: { disabled: !item.canPreview() },
                            on: {
                              click: function ($event) {
                                return _vm.openPreview(item)
                              },
                            },
                          },
                          [_c("w-fa", { attrs: { icon: "eye" } })],
                          1
                        )
                      : _c("w-progress-circular", { attrs: { small: "" } }),
                  ],
                  1
                ),
                _c(
                  "w-list-item-action",
                  [
                    _c(
                      "w-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("common.download"),
                            expression: "$ct('common.download')",
                          },
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.download(item)
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "download" } })],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          _c(
            "w-modal",
            {
              model: {
                value: _vm.showPreview,
                callback: function ($$v) {
                  _vm.showPreview = $$v
                },
                expression: "showPreview",
              },
            },
            [
              _c("app-preview", {
                attrs: { file: _vm.previewFile },
                on: {
                  close: function ($event) {
                    _vm.showPreview = false
                  },
                },
              }),
            ],
            1
          ),
        ],
        2
      )
    : _vm.isAllowed
    ? _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c("w-col", { attrs: { xs: "12" } }, [
                _vm._v(" " + _vm._s(_vm.$ct("common.empty-list")) + " "),
              ]),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }